import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

// Components
import { HeaderPanelComponent } from './header-panel.component';
import { SearchComponent } from './search/search.component';
import { LanguageComponent } from './language/language.component';

// Module of componentsR
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CustomSearchesComponent } from './custom-searches/custom-searches.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { LinkToWebgisAppsComponent } from '../tools/link-to-webgis-apps/link-to-webgis-apps.component';
import { ArbeitsbereichComponent } from './arbeitsbereich/arbeitsbereich.component';
import { CommonModule } from '@angular/common';

export const HEADER_PANEL_COMPONENTS = [
  HeaderPanelComponent,
  ArbeitsbereichComponent,
  SearchComponent,
  LanguageComponent,
  CustomSearchesComponent,
  SidebarComponent,
  LinkToWebgisAppsComponent,
];

@NgModule({
  declarations: HEADER_PANEL_COMPONENTS,
  imports: [RouterModule, TranslateModule, CommonModule, BsDropdownModule.forRoot()],
  exports: HEADER_PANEL_COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderPanelModule {}
